import { PreferencesRepository } from "../../adapters/preferencesRepository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: PreferencesRepository): Interactor {
  return (preferences) =>
    present(
      repository
        .updatePreferences(preferences)
        .then(() => preferences)
        .catch(() => preferences),
    );
}

export type { Interactor };

export { createInteractor };
